import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { AuthorizedIssuedVouchersProvaider } from "./Context";
import context from "./Context";
import TableVoucherAuthorized from "./Table";
import Filters from "./filters";
import { useSelector } from 'react-redux';

const useStyles = makeStyles(() => ({
    root: {
        paddingTop: '50px',
        flexGrow: 1,
        paddingLeft: '3%',
        paddingRight: '3%',
        marginBottom: '50px',
        paddingBottom: '50px',
    },
}));

const Content = ({ rucEnterprise }) => {

    const classesView = useStyles();

    const { state } = useContext(context);

    const cufes = state.page?.content?.map(
        item => item.comprobanteElectronico?.cufe
    ).filter(Boolean) || [];

    return (
        <div className={classesView.root}>

            <Filters totalElements={cufes} />

            <TableVoucherAuthorized
                rucEnterprise={rucEnterprise}
            />
        </div>
    );
};

const VoucherAuthorized = () => {

    const rucEnterprise = useSelector(state => state.user?.ruc) || "";

    return (
        <AuthorizedIssuedVouchersProvaider>
            <Content rucEnterprise={rucEnterprise} />
        </AuthorizedIssuedVouchersProvaider>
    );
};

export default VoucherAuthorized;